import React from "react"
import Getstarted from "./getstarted.module.scss"
import text from "../styles/typography.module.scss"
import button from "./button.module.scss"
import {Link} from "gatsby"

export default function getstarted(props) {
  return (
    <div className={Getstarted.container}>
      <div className={Getstarted.wrapper}>
        <h2 className={text.heading2}>{"Ready to get started?"}</h2>
        <p className={text.paragraph}>{"Enhance your meeting experience today with Minutscript."}</p>
        <div className={Getstarted.buttons}>
          <Link
            to="/404/"
            className={`${button.btn} ${button.cta}`}
          >
            Get app
          </Link>
          { props.primary ? <Link to="/pricing/" className={`${button.btn} ${button.primary}`}> See pricing </Link> : ""} 
        </div>
      </div>
    </div>
  )
}
